import type { ProductProfile } from "../../../shared/goals/profile";
import type { Block, Doc } from "../library/parts";
import { allRules, walkParts } from "./walk";

const block = (text: string): Block => ({ t: "p", lvl: 0, text, from: 0, to: 0 });
const paras = (text: string) =>
  text
    .split(/\n\s*\n/)
    .map((t) => t.trim())
    .filter(Boolean);

/** A profile version as parts to compare, in the walk's own parts and names. */
export function profileDoc(p: ProductProfile): Doc {
  const notes = p.owner?.notes ?? {};
  const off = new Map((p.owner?.rules_off ?? []).map((r) => [r.rule, r.right]));
  const parts = walkParts(p).map((part) => {
    const out: string[] = [];
    if (part.kind === "site") out.push(`${p.business} · ${p.website}`, ...paras(p.summary));
    for (const id of part.secs) {
      const s = p.sections.find((x) => x.id === id);
      if (s) out.push(...paras(s.text));
      if (notes[id]) out.push(`Your note: ${notes[id]}`);
    }
    if (part.kind === "found") {
      for (const x of p.problems) out.push(`${x.problem} · ${x.where} · ${x.fix}${x.review?.mark === "wrong" ? ` · Not right: ${x.review.right}` : ""}`);
      for (const r of allRules(p)) out.push(off.has(r) ? `Taken out: ${r}${off.get(r) ? ` · ${off.get(r)}` : ""}` : `Rule: ${r}`);
      for (const b of p.calls_to_action) out.push(`Button: ${b.label} · ${b.lands_on} · ${b.checked}`);
      for (const x of p.presence) out.push(`${x.channel}: ${x.seen}`);
      for (const x of p.market) out.push(`${x.fact} (${x.source})`);
    }
    if (part.kind === "more" && p.owner?.extra) out.push(...paras(p.owner.extra));
    for (const k of part.qs) {
      const q = p.questions[k];
      if (q) out.push(`${q.question} ${q.answer ? `Your answer: ${q.answer}` : "Not answered"}`);
    }
    return { id: part.id, title: part.title, blocks: out.map(block) };
  });
  return { title: p.business, rules: [], written: null, parts };
}
